export const settingsTranslations = {
  ar: {
    invoiceSettings: 'إعدادات الفواتير',
    invoiceSettingsDescription: 'تخصيص إعدادات الفواتير والتحقق من البيانات',
    paymentMethods: 'طرق الدفع',
    basicValidation: 'التحقق الأساسي',
    itemValidation: 'التحقق من الأصناف',
    totalsValidation: 'التحقق من الإجماليات',
    discountValidation: 'التحقق من الخصومات',
    additionalFieldsValidation: 'التحقق من الحقول الإضافية',
    autoSettings: 'الإعدادات التلقائية',
    fieldVisibility: 'إظهار/إخفاء الحقول',
    businessRules: 'قواعد العمل',
    settingsScope: 'نطاق الإعدادات',
    forUser: 'للمستخدم',
    forCompany: 'للشركة',
    forBranch: 'للفرع',
    defaultValues: 'القيم الافتراضية',
    defaultDate: 'التاريخ الافتراضي',
    defaultDateToday: 'اليوم',
    defaultDateYesterday: 'أمس',
    defaultDateLastMonth: 'آخر شهر',
    defaultDateCustom: 'مخصص',
    defaultBranch: 'الفرع الافتراضي',
    defaultStore: 'المخزن الافتراضي',
    defaultPaymentMethod: 'طريقة الدفع الافتراضية',
    requireBranch: 'إجبار الفرع',
    requireStore: 'إجبار المخزن',
    requirePaymentMethod: 'إجبار طريقة الدفع',
    requireDate: 'إجبار التاريخ',
    requireCustomer: 'إجبار العميل',
    requireContactId: 'إجبار معرف العميل',
    requireItemUnit: 'إجبار الوحدة',
    requireItemQuantity: 'إجبار الكمية',
    requireItemPrice: 'إجبار السعر',
    requireItemTax: 'إجبار الضريبة',
    requireItemBeforeAdding: 'إجبار المخزن قبل الإضافة',
    requireItemDiscount: 'إجبار خصم الصنف',
    requireItemBarcode: 'إجبار الباركود',
    requireTotalGreaterThanZero: 'إجمالي أكبر من صفر',
    requireGrossTotalGreaterThanZero: 'إجمالي إجمالي أكبر من صفر',
    requireTotalTaxGreaterThanZero: 'ضريبة أكبر من صفر',
    requireFirstPaid: 'إجبار المدفوع',
    requireFinalNet: 'إجبار الصافي النهائي',
    requirePercentageDiscount: 'إجبار خصم النسبة',
    requireCashDiscount: 'إجبار خصم نقدي',
    requireTotalDiscount: 'إجبار إجمالي الخصم',
    forceDiscount: 'إجبار الخصم',
    requireUserRefNo: 'إجبار رقم المرجع',
    requireNotes: 'إجبار الملاحظات',
    requireCustomerAddress: 'إجبار العنوان',
    requireDateDelivery: 'إجبار تاريخ التسليم',
    requireDriver: 'إجبار السائق',
    requireSalesRep: 'إجبار المندوب',
    requireCashAccount: 'إجبار حساب النقدية',
    requireAdditionals: 'إجبار الإضافات',
    requireSerial: 'إجبار الرقم التسلسلي',
    autoLift: 'الرفع التلقائي',
    autoApprove: 'الموافقة التلقائية',
    autoGenerateSerial: 'توليد رقم تلقائي',
    autoCalculateTax: 'حساب الضريبة تلقائياً',
    autoCalculateDiscount: 'حساب الخصم تلقائياً',
    showCustomerAddress: 'عنوان العميل',
    showNotes: 'الملاحظات',
    showUserRefNo: 'رقم المرجع',
    showDateDelivery: 'تاريخ التسليم',
    showDriver: 'السائق',
    showCashAccount: 'حساب النقدية',
    showPercentageDiscount: 'خصم النسبة',
    showCashDiscount: 'خصم نقدي',
    showAdditionals: 'الإضافات',
    showSerial: 'الرقم التسلسلي',
    showCustomerCode: 'كود العميل',
    showCustomerMobile: 'جوال العميل',
    showGiftItem: 'صنف هدية',
    allowEmptyFields: 'السماح بالحقول الفارغة',
    allowNegativeQuantities: 'السماح بالكميات السالبة',
    allowZeroPrice: 'السماح بالسعر صفر',
    allowSellBelowCost: 'السماح بالبيع تحت سعر التكلفة',
    allowEditAfterSave: 'السماح بالتعديل بعد الحفظ',
    allowEditDefaultFields: 'السماح بتعديل البيانات الافتراضية',
    allowDeleteAfterSave: 'السماح بالحذف بعد الحفظ',
    requireApproval: 'إجبار الموافقة',
    approvalAmountThreshold: 'حد المبلغ الذي يتطلب موافقة',
    approvalDiscountPercentThreshold: 'نسبة الخصم التي تتطلب موافقة',
    hints: {
      requireBranch: 'يمنع حفظ الفاتورة إذا لم يُحدد الفرع',
      requireStore: 'يمنع حفظ الفاتورة إذا لم يُحدد المخزن',
      requirePaymentMethod: 'يمنع الحفظ بدون اختيار طريقة الدفع (نقدي أو آجل)',
      requireDate: 'يمنع الحفظ إذا كان تاريخ الفاتورة فارغاً',
      requireCustomer: 'يمنع الحفظ بدون اختيار عميل',
      requireContactId: 'يشترط وجود معرف جهة الاتصال حتى لو ظهر الاسم',
      requireItemUnit: 'لا يُضاف السطر بدون وحدة للصنف',
      requireItemQuantity: 'لا يُضاف السطر إذا كانت الكمية فارغة أو صفراً',
      requireItemPrice: 'لا يُضاف السطر بدون سعر',
      requireItemTax: 'يشترط تحديد ضريبة لكل صنف',
      requireItemBeforeAdding: 'يجب اختيار المخزن قبل إضافة أي صنف',
      requireItemDiscount: 'يشترط إدخال خصم على سطر الصنف',
      requireItemBarcode: 'يشترط وجود باركود للصنف قبل إضافته',
      requireTotalGreaterThanZero: 'يرفض الحفظ إذا كان صافي الفاتورة صفراً أو أقل',
      requireGrossTotalGreaterThanZero: 'يرفض الحفظ إذا كان الإجمالي قبل الخصم صفراً أو أقل',
      requireTotalTaxGreaterThanZero: 'يرفض الحفظ إذا كانت قيمة الضريبة صفراً',
      requireFirstPaid: 'يشترط إدخال مبلغ مدفوع في الفاتورة',
      requireFinalNet: 'يشترط وجود قيمة للصافي النهائي',
      requirePercentageDiscount: 'يشترط إدخال خصم نسبة في رأس الفاتورة',
      requireCashDiscount: 'يشترط إدخال خصم نقدي في رأس الفاتورة',
      requireTotalDiscount: 'يشترط وجود إجمالي خصم أكبر من صفر',
      forceDiscount: 'يجبر المستخدم على تطبيق خصم قبل الحفظ',
      requireUserRefNo: 'يشترط رقم مرجع خارجي (أمر شراء أو رقم العميل)',
      requireNotes: 'يشترط كتابة ملاحظات قبل الحفظ',
      requireCustomerAddress: 'يشترط عنوان التسليم أو عنوان العميل',
      requireDateDelivery: 'يشترط تاريخ التسليم',
      requireDriver: 'يشترط اختيار سائق',
      requireSalesRep: 'يشترط اختيار مندوب مبيعات',
      requireCashAccount: 'يشترط حساب الصندوق في الفواتير النقدية',
      requireAdditionals: 'يشترط تعبئة حقول الإضافات',
      requireSerial: 'يشترط الرقم التسلسلي للفاتورة',
      autoLift: 'يرحّل الفاتورة تلقائياً بعد الحفظ (تحديث المخزون والقيود) دون رفع يدوي',
      autoApprove: 'تعتمد الفاتورة تلقائياً بعد الحفظ دون انتظار موافقة',
      autoGenerateSerial: 'يولّد رقم الفاتورة تلقائياً من نظام الترقيم عند الحفظ',
      autoCalculateTax: 'يحسب ضريبة الأصناف والإجمالي تلقائياً حسب إعداد الضريبة',
      autoCalculateDiscount: 'يعيد حساب الخصم والإجماليات تلقائياً عند تغيير الكمية أو السعر',
      showCustomerAddress: 'يظهر حقل عنوان العميل في رأس الفاتورة',
      showNotes: 'يظهر حقل الملاحظات في الفاتورة',
      showUserRefNo: 'يظهر حقل رقم المرجع',
      showDateDelivery: 'يظهر حقل تاريخ التسليم',
      showDriver: 'يظهر حقل السائق',
      showCashAccount: 'يظهر حقل حساب الصندوق',
      showPercentageDiscount: 'يظهر حقل خصم النسبة في الرأس',
      showCashDiscount: 'يظهر حقل الخصم النقدي في الرأس',
      showAdditionals: 'يظهر حقول الإضافات',
      showSerial: 'يظهر الرقم التسلسلي في الشاشة',
      showCustomerCode: 'يظهر كود العميل بجانب الاسم',
      showCustomerMobile: 'يظهر رقم جوال العميل في الرأس',
      showItemExpiryDate: 'يظهر تاريخ الانتهاء في أسطر فاتورة المشتريات',
      showGiftItem: 'يظهر خيار صنف الهدية في سطر الفاتورة',
      posAddNewItemToTop: 'الصنف الجديد يظهر أول السلة في نقطة البيع بدل آخرها',
      autoPrint: 'تُطبع الفاتورة مباشرة بعد الحفظ الناجح',
      allowEmptyFields: 'يسمح بالحفظ حتى لو بقيت بعض الحقول فارغة (يتجاوز جزءاً من التحقق)',
      allowNegativeQuantities: 'يسمح بكمية سالبة في السطر (مرتجع أو تسوية)',
      allowZeroPrice: 'يسمح بحفظ صنف بسعر صفر',
      allowSellBelowCost: 'يسمح بحفظ فاتورة البيع عندما يكون السعر أقل من التكلفة (مع تحذير)',
      enforceMinimumPrice: 'يمنع البيع بأقل من الحد الأدنى لسعر الصنف',
      allowEditAfterSave: 'يسمح بتعديل الفاتورة بعد حفظها (ما لم تمنعها صلاحية أخرى)',
      allowEditDefaultFields: 'عند الإيقاف تُقفل حقول الرأس المعبأة تلقائياً (فرع، مخزن، عميل، طريقة دفع، مندوب، تاريخ). صلاحيات القفل تبقى سارية.',
      allowDeleteAfterSave: 'يسمح بحذف الفاتورة بعد حفظها حسب صلاحية المستخدم',
      requireApproval: 'لا تُعتمد الفاتورة إلا بموافقة، ويمكن تحديد حد مبلغ أو نسبة خصم',
      preventItemDuplication: 'يمنع إضافة نفس الصنف أكثر من مرة في الفاتورة',
      mergeQuantitiesOnDuplicate: 'إذا تكرر الصنف تُدمج الكمية في سطر واحد بدل سطر جديد',
      defaultSalesItemsStockOnly: 'عند أول فتح للفاتورة تُعرض الأصناف ذات الرصيد فقط، ويؤثر على الباركود وقائمة الاختيار',
      allowRepPriceEdit: 'يسمح للمندوب بتغيير سعر البيع من التطبيق',
      allowRepInvoiceEdit: 'يسمح للمندوب بتعديل فاتورة محفوظة من التطبيق',
      showRepCostPrice: 'يظهر سعر التكلفة للمندوب في التطبيق',
      repEnforceCostFloor: 'يمنع المندوب من البيع بأقل من التكلفة',
      allowRepReturns: 'يظهر مرتجع المبيعات في تطبيق المندوب إذا مُنحت صلاحية الشاشة',
      allowRepPurchases: 'يظهر فاتورة الشراء في تطبيق المندوب إذا مُنحت صلاحية الشاشة',
      allowRepPurchaseReturns: 'يظهر مرتجع الشراء في تطبيق المندوب إذا مُنحت صلاحية الشاشة',
      allowRepOpeningStock: 'يفتح شاشة جرد (باركود وكميات) وتُحفظ كفاتورة أول مدة',
      allowRepStockRequest: 'يسمح للمندوب بطلب بضاعة من المستودع',
      allowRepTransferRequest: 'يسمح بطلب مناقلة ويحتاج موافقة قبل التنفيذ',
      repNotifyAdminOnSale: 'يرسل إشعاراً للإدارة عند كل عملية بيع من التطبيق',
      repEnableLocationTracking: 'يسجّل موقع المندوب أثناء العمل عبر GPS',
    },
  },
  en: {
    invoiceSettings: 'Invoice Settings',
    invoiceSettingsDescription: 'Customize invoice settings and data validation',
    paymentMethods: 'Payment Methods',
    basicValidation: 'Basic Validation',
    itemValidation: 'Item Validation',
    totalsValidation: 'Totals Validation',
    discountValidation: 'Discount Validation',
    additionalFieldsValidation: 'Additional Fields Validation',
    autoSettings: 'Auto Settings',
    fieldVisibility: 'Field Visibility',
    businessRules: 'Business Rules',
    settingsScope: 'Settings Scope',
    forUser: 'For User',
    forCompany: 'For Company',
    forBranch: 'For Branch',
    defaultValues: 'Default Values',
    defaultDate: 'Default Date',
    defaultDateToday: 'Today',
    defaultDateYesterday: 'Yesterday',
    defaultDateLastMonth: 'Last Month',
    defaultDateCustom: 'Custom',
    defaultBranch: 'Default Branch',
    defaultStore: 'Default Store',
    defaultPaymentMethod: 'Default Payment Method',
    requireBranch: 'Require Branch',
    requireStore: 'Require Store',
    requirePaymentMethod: 'Require Payment Method',
    requireDate: 'Require Date',
    requireCustomer: 'Require Customer',
    requireContactId: 'Require Contact ID',
    requireItemUnit: 'Require Unit',
    requireItemQuantity: 'Require Quantity',
    requireItemPrice: 'Require Price',
    requireItemTax: 'Require Tax',
    requireItemBeforeAdding: 'Require Store Before Adding',
    requireItemDiscount: 'Require Item Discount',
    requireItemBarcode: 'Require Barcode',
    requireTotalGreaterThanZero: 'Total > 0',
    requireGrossTotalGreaterThanZero: 'Gross Total > 0',
    requireTotalTaxGreaterThanZero: 'Tax > 0',
    requireFirstPaid: 'Require First Paid',
    requireFinalNet: 'Require Final Net',
    requirePercentageDiscount: 'Require % Discount',
    requireCashDiscount: 'Require Cash Discount',
    requireTotalDiscount: 'Require Total Discount',
    forceDiscount: 'Force Discount',
    requireUserRefNo: 'Require Ref No',
    requireNotes: 'Require Notes',
    requireCustomerAddress: 'Require Address',
    requireDateDelivery: 'Require Delivery Date',
    requireDriver: 'Require Driver',
    requireSalesRep: 'Require Sales Representative',
    requireCashAccount: 'Require Cash Account',
    requireAdditionals: 'Require Additionals',
    requireSerial: 'Require Serial',
    autoLift: 'Auto Lift',
    autoApprove: 'Auto Approve',
    autoGenerateSerial: 'Auto Generate Serial',
    autoCalculateTax: 'Auto Calculate Tax',
    autoCalculateDiscount: 'Auto Calculate Discount',
    showCustomerAddress: 'Customer Address',
    showNotes: 'Notes',
    showUserRefNo: 'Ref No',
    showDateDelivery: 'Delivery Date',
    showDriver: 'Driver',
    showCashAccount: 'Cash Account',
    showPercentageDiscount: '% Discount',
    showCashDiscount: 'Cash Discount',
    showAdditionals: 'Additionals',
    showSerial: 'Serial',
    showCustomerCode: 'Customer Code',
    showCustomerMobile: 'Customer Mobile',
    showGiftItem: 'Gift Item',
    allowEmptyFields: 'Allow Empty Fields',
    allowNegativeQuantities: 'Allow Negative Quantities',
    allowZeroPrice: 'Allow Zero Price',
    allowSellBelowCost: 'Allow selling below cost',
    allowEditAfterSave: 'Allow Edit After Save',
    allowEditDefaultFields: 'Allow Editing Default Fields',
    allowDeleteAfterSave: 'Allow Delete After Save',
    requireApproval: 'Require Approval',
    approvalAmountThreshold: 'Approval Amount Threshold',
    approvalDiscountPercentThreshold: 'Approval Discount % Threshold',
    hints: {
      requireBranch: 'Blocks save if no branch is selected',
      requireStore: 'Blocks save if no warehouse is selected',
      requirePaymentMethod: 'Blocks save until cash or credit is chosen',
      requireDate: 'Blocks save if the invoice date is empty',
      requireCustomer: 'Blocks save until a customer is selected',
      requireContactId: 'Requires a contact ID even if a name is shown',
      requireItemUnit: 'A line cannot be added without an item unit',
      requireItemQuantity: 'A line cannot be added with empty or zero quantity',
      requireItemPrice: 'A line cannot be added without a price',
      requireItemTax: 'Each item must have a tax selected',
      requireItemBeforeAdding: 'A warehouse must be chosen before adding items',
      requireItemDiscount: 'Requires a discount value on the item line',
      requireItemBarcode: 'Requires a barcode before the item can be added',
      requireTotalGreaterThanZero: 'Blocks save if net total is zero or less',
      requireGrossTotalGreaterThanZero: 'Blocks save if gross total is zero or less',
      requireTotalTaxGreaterThanZero: 'Blocks save if tax amount is zero',
      requireFirstPaid: 'Requires a paid amount on the invoice',
      requireFinalNet: 'Requires a final net amount',
      requirePercentageDiscount: 'Requires a percentage discount on the header',
      requireCashDiscount: 'Requires a cash discount on the header',
      requireTotalDiscount: 'Requires a total discount greater than zero',
      forceDiscount: 'Forces the user to apply a discount before save',
      requireUserRefNo: 'Requires an external reference number',
      requireNotes: 'Requires notes before save',
      requireCustomerAddress: 'Requires a delivery or customer address',
      requireDateDelivery: 'Requires a delivery date',
      requireDriver: 'Requires a driver',
      requireSalesRep: 'Requires a sales representative',
      requireCashAccount: 'Requires a cash account on cash invoices',
      requireAdditionals: 'Requires additional-charge fields',
      requireSerial: 'Requires an invoice serial number',
      autoLift: 'Posts the invoice automatically after save (stock and journal) without a manual lift',
      autoApprove: 'Approves the invoice automatically after save',
      autoGenerateSerial: 'Assigns the next document number on save',
      autoCalculateTax: 'Recalculates item and invoice tax from tax settings',
      autoCalculateDiscount: 'Recalculates discount and totals when qty or price changes',
      showCustomerAddress: 'Shows the customer address field on the invoice',
      showNotes: 'Shows the notes field',
      showUserRefNo: 'Shows the reference-number field',
      showDateDelivery: 'Shows the delivery-date field',
      showDriver: 'Shows the driver field',
      showCashAccount: 'Shows the cash-account field',
      showPercentageDiscount: 'Shows header percentage discount',
      showCashDiscount: 'Shows header cash discount',
      showAdditionals: 'Shows additional-charge fields',
      showSerial: 'Shows the serial number on screen',
      showCustomerCode: 'Shows the customer code next to the name',
      showCustomerMobile: 'Shows the customer mobile on the header',
      showItemExpiryDate: 'Shows expiry date on purchase invoice lines',
      showGiftItem: 'Shows the gift-item option on invoice lines',
      posAddNewItemToTop: 'New POS items appear at the top of the cart',
      autoPrint: 'Prints the invoice immediately after a successful save',
      allowEmptyFields: 'Allows save even if some fields are empty (bypasses part of validation)',
      allowNegativeQuantities: 'Allows negative line quantities (return or adjustment)',
      allowZeroPrice: 'Allows saving an item with a zero price',
      allowSellBelowCost: 'Allows saving a sales invoice when price is below cost (with a warning)',
      enforceMinimumPrice: 'Blocks selling below the item’s minimum price',
      allowEditAfterSave: 'Allows editing a saved invoice unless another permission blocks it',
      allowEditDefaultFields: 'When off, auto-filled header fields (branch, store, customer, payment, sales rep, date) are locked. Lock permissions still apply.',
      allowDeleteAfterSave: 'Allows deleting a saved invoice according to user permission',
      requireApproval: 'Invoice stays unapproved until approval; optional amount or discount thresholds apply',
      preventItemDuplication: 'Prevents adding the same item more than once',
      mergeQuantitiesOnDuplicate: 'Merges quantity into the existing line instead of adding a duplicate',
      defaultSalesItemsStockOnly: 'On first open, only items with stock are listed; also affects barcode lookup',
      allowRepPriceEdit: 'Lets the rep change selling price in the mobile app',
      allowRepInvoiceEdit: 'Lets the rep edit a saved invoice in the mobile app',
      showRepCostPrice: 'Shows cost price to the rep in the mobile app',
      repEnforceCostFloor: 'Blocks the rep from selling below cost',
      allowRepReturns: 'Shows sales returns in the rep app when screen permission is granted',
      allowRepPurchases: 'Shows purchase invoices in the rep app when screen permission is granted',
      allowRepPurchaseReturns: 'Shows purchase returns in the rep app when screen permission is granted',
      allowRepOpeningStock: 'Opens a barcode count screen and saves it as an opening-stock invoice',
      allowRepStockRequest: 'Lets the rep request stock from the warehouse',
      allowRepTransferRequest: 'Lets the rep request a transfer; approval is required',
      repNotifyAdminOnSale: 'Notifies admin on every sale from the mobile app',
      repEnableLocationTracking: 'Records the rep’s GPS location while working',
    },
  },
  fr: {
    invoiceSettings: 'Paramètres de facture',
    invoiceSettingsDescription: 'Personnaliser les paramètres de facture et la validation des données',
    paymentMethods: 'Modes de paiement',
    basicValidation: 'Validation de base',
    itemValidation: 'Validation des articles',
    totalsValidation: 'Validation des totaux',
    discountValidation: 'Validation des remises',
    additionalFieldsValidation: 'Validation des champs supplémentaires',
    autoSettings: 'Paramètres automatiques',
    fieldVisibility: 'Visibilité des champs',
    businessRules: 'Règles métier',
    settingsScope: 'Portée des paramètres',
    forUser: 'Pour l\'utilisateur',
    forCompany: 'Pour l\'entreprise',
    forBranch: 'Pour la succursale',
    defaultValues: 'Valeurs par défaut',
    defaultDate: 'Date par défaut',
    defaultDateToday: 'Aujourd\'hui',
    defaultDateYesterday: 'Hier',
    defaultDateLastMonth: 'Dernier mois',
    defaultDateCustom: 'Personnalisé',
    defaultBranch: 'Succursale par défaut',
    defaultStore: 'Magasin par défaut',
    defaultPaymentMethod: 'Mode de paiement par défaut',
    requireBranch: 'Exiger la succursale',
    requireStore: 'Exiger le magasin',
    requirePaymentMethod: 'Exiger le mode de paiement',
    requireDate: 'Exiger la date',
    requireCustomer: 'Exiger le client',
    requireContactId: 'Exiger l\'ID du contact',
    requireItemUnit: 'Exiger l\'unité',
    requireItemQuantity: 'Exiger la quantité',
    requireItemPrice: 'Exiger le prix',
    requireItemTax: 'Exiger la taxe',
    requireItemBeforeAdding: 'Exiger le magasin avant l\'ajout',
    requireItemDiscount: 'Exiger la remise sur l\'article',
    requireItemBarcode: 'Exiger le code-barres',
    requireTotalGreaterThanZero: 'Total > 0',
    requireGrossTotalGreaterThanZero: 'Total brut > 0',
    requireTotalTaxGreaterThanZero: 'Taxe > 0',
    requireFirstPaid: 'Exiger le premier paiement',
    requireFinalNet: 'Exiger le net final',
    requirePercentageDiscount: 'Exiger la remise %',
    requireCashDiscount: 'Exiger la remise en espèces',
    requireTotalDiscount: 'Exiger la remise totale',
    forceDiscount: 'Forcer la remise',
    requireUserRefNo: 'Exiger le numéro de référence',
    requireNotes: 'Exiger les notes',
    requireCustomerAddress: 'Exiger l\'adresse',
    requireDateDelivery: 'Exiger la date de livraison',
    requireDriver: 'Exiger le chauffeur',
    requireSalesRep: 'Exiger le représentant commercial',
    requireCashAccount: 'Exiger le compte de trésorerie',
    requireAdditionals: 'Exiger les suppléments',
    requireSerial: 'Exiger le numéro de série',
    autoLift: 'Levée automatique',
    autoApprove: 'Approbation automatique',
    autoGenerateSerial: 'Génération automatique du numéro',
    autoCalculateTax: 'Calcul automatique de la taxe',
    autoCalculateDiscount: 'Calcul automatique de la remise',
    showCustomerAddress: 'Adresse du client',
    showNotes: 'Notes',
    showUserRefNo: 'Numéro de référence',
    showDateDelivery: 'Date de livraison',
    showDriver: 'Chauffeur',
    showCashAccount: 'Compte de trésorerie',
    showPercentageDiscount: 'Remise %',
    showCashDiscount: 'Remise en espèces',
    showAdditionals: 'Suppléments',
    showSerial: 'Numéro de série',
    showCustomerCode: 'Code client',
    showCustomerMobile: 'Mobile client',
    showGiftItem: 'Article cadeau',
    allowEmptyFields: 'Autoriser les champs vides',
    allowNegativeQuantities: 'Autoriser les quantités négatives',
    allowZeroPrice: 'Autoriser le prix zéro',
    allowSellBelowCost: 'Autoriser la vente sous le coût',
    allowEditAfterSave: 'Autoriser la modification après sauvegarde',
    allowEditDefaultFields: 'Autoriser la modification des champs par défaut',
    allowDeleteAfterSave: 'Autoriser la suppression après sauvegarde',
    requireApproval: 'Exiger l\'approbation',
    approvalAmountThreshold: 'Seuil de montant nécessitant approbation',
    approvalDiscountPercentThreshold: 'Seuil de remise (%) nécessitant approbation',
    hints: {
      requireBranch: 'Empêche l’enregistrement sans succursale',
      requireStore: 'Empêche l’enregistrement sans magasin',
      requirePaymentMethod: 'Empêche l’enregistrement sans mode de paiement',
      requireDate: 'Empêche l’enregistrement si la date est vide',
      requireCustomer: 'Empêche l’enregistrement sans client',
      requireContactId: 'Exige l’identifiant du contact même si le nom apparaît',
      requireItemUnit: 'La ligne ne peut pas être ajoutée sans unité',
      requireItemQuantity: 'La ligne ne peut pas être ajoutée avec une quantité vide ou nulle',
      requireItemPrice: 'La ligne ne peut pas être ajoutée sans prix',
      requireItemTax: 'Chaque article doit avoir une taxe',
      requireItemBeforeAdding: 'Un magasin doit être choisi avant d’ajouter des articles',
      requireItemDiscount: 'Exige une remise sur la ligne article',
      requireItemBarcode: 'Exige un code-barres avant d’ajouter l’article',
      requireTotalGreaterThanZero: 'Empêche l’enregistrement si le net est zéro ou moins',
      requireGrossTotalGreaterThanZero: 'Empêche l’enregistrement si le brut est zéro ou moins',
      requireTotalTaxGreaterThanZero: 'Empêche l’enregistrement si la taxe est zéro',
      requireFirstPaid: 'Exige un montant payé',
      requireFinalNet: 'Exige un net final',
      requirePercentageDiscount: 'Exige une remise en % sur l’en-tête',
      requireCashDiscount: 'Exige une remise en espèces sur l’en-tête',
      requireTotalDiscount: 'Exige une remise totale supérieure à zéro',
      forceDiscount: 'Oblige l’utilisateur à appliquer une remise avant l’enregistrement',
      requireUserRefNo: 'Exige un numéro de référence externe',
      requireNotes: 'Exige des notes avant l’enregistrement',
      requireCustomerAddress: 'Exige une adresse de livraison ou client',
      requireDateDelivery: 'Exige une date de livraison',
      requireDriver: 'Exige un chauffeur',
      requireSalesRep: 'Exige un représentant',
      requireCashAccount: 'Exige un compte de caisse sur les factures cash',
      requireAdditionals: 'Exige les champs supplémentaires',
      requireSerial: 'Exige un numéro de série',
      autoLift: 'Comptabilise automatiquement la facture après enregistrement (stock et écriture)',
      autoApprove: 'Approuve automatiquement la facture après enregistrement',
      autoGenerateSerial: 'Attribue le prochain numéro de document à l’enregistrement',
      autoCalculateTax: 'Recalcule la taxe des articles et de la facture',
      autoCalculateDiscount: 'Recalcule la remise et les totaux quand la qté ou le prix change',
      showCustomerAddress: 'Affiche l’adresse du client',
      showNotes: 'Affiche le champ notes',
      showUserRefNo: 'Affiche le numéro de référence',
      showDateDelivery: 'Affiche la date de livraison',
      showDriver: 'Affiche le champ chauffeur',
      showCashAccount: 'Affiche le compte de caisse',
      showPercentageDiscount: 'Affiche la remise % d’en-tête',
      showCashDiscount: 'Affiche la remise en espèces d’en-tête',
      showAdditionals: 'Affiche les champs supplémentaires',
      showSerial: 'Affiche le numéro de série à l’écran',
      showCustomerCode: 'Affiche le code client à côté du nom',
      showCustomerMobile: 'Affiche le mobile du client',
      showItemExpiryDate: 'Affiche la date de péremption sur les lignes d’achat',
      showGiftItem: 'Affiche l’option article cadeau',
      posAddNewItemToTop: 'Les nouveaux articles POS apparaissent en haut du panier',
      autoPrint: 'Imprime la facture juste après un enregistrement réussi',
      allowEmptyFields: 'Autorise l’enregistrement même si certains champs sont vides',
      allowNegativeQuantities: 'Autorise des quantités négatives (retour ou ajustement)',
      allowZeroPrice: 'Autorise un prix à zéro',
      allowSellBelowCost: 'Autorise une facture de vente sous le coût (avec avertissement)',
      enforceMinimumPrice: 'Empêche la vente sous le prix minimum',
      allowEditAfterSave: 'Autorise la modification après enregistrement sauf autre restriction',
      allowEditDefaultFields: 'Si désactivé, les champs d’en-tête auto-remplis (succursale, magasin, client, paiement, représentant, date) sont verrouillés.',
      allowDeleteAfterSave: 'Autorise la suppression après enregistrement selon la permission',
      requireApproval: 'La facture reste non approuvée jusqu’à validation ; seuils optionnels',
      preventItemDuplication: 'Empêche d’ajouter le même article plus d’une fois',
      mergeQuantitiesOnDuplicate: 'Fusionne la quantité sur la ligne existante',
      defaultSalesItemsStockOnly: 'Au premier ouverture, seuls les articles en stock sont listés',
      allowRepPriceEdit: 'Autorise le représentant à modifier le prix dans l’app',
      allowRepInvoiceEdit: 'Autorise le représentant à modifier une facture enregistrée',
      showRepCostPrice: 'Affiche le coût au représentant',
      repEnforceCostFloor: 'Empêche la vente sous le coût',
      allowRepReturns: 'Affiche les retours ventes dans l’app si la permission existe',
      allowRepPurchases: 'Affiche les factures d’achat dans l’app si la permission existe',
      allowRepPurchaseReturns: 'Affiche les retours achat dans l’app si la permission existe',
      allowRepOpeningStock: 'Ouvre un inventaire code-barres enregistré comme stock d’ouverture',
      allowRepStockRequest: 'Autorise une demande de stock',
      allowRepTransferRequest: 'Autorise une demande de transfert (approbation requise)',
      repNotifyAdminOnSale: 'Notifie l’admin à chaque vente depuis l’app',
      repEnableLocationTracking: 'Enregistre la position GPS du représentant',
    },
  },
};
